import { useAppDispatch } from 'store/hooks';
import reportSelectors from '../selectors';
import { useCallback, useEffect } from 'react';
import reportActions from '../actions';
import { IStaffAdjustmentSaleParams } from '../types/api';

const useGetListSaleAdjustment = (isLazy = false) => {
  const dispatch = useAppDispatch();
  const listSaleAdjustment = reportSelectors.getListSaleAdjustment();
  const saleAdjustmentParams = reportSelectors.getListSaleAdjustmentParams();

  const mutate = useCallback(
    (params: IStaffAdjustmentSaleParams) => {
      dispatch(reportActions.setSaleAdjustmentParams(params));
    },
    [dispatch],
  );

  useEffect(() => {
    if (isLazy) return;
    mutate(saleAdjustmentParams);
  }, []);

  return {
    listSaleAdjustment,
    saleAdjustmentParams,
    mutate,
  };
};

export default useGetListSaleAdjustment;